import { required, email, max, integer } from 'vee-validate/dist/rules'
import { extend } from 'vee-validate'
import {
  isKana,
  isKanaAlphabet,
  isPhoneNumber,
  isCellPhoneNumber,
  isCellPhoneNumberWithOptionalLeadingZero,
  isPostalCode,
  isURL,
  isInternationalPhoneNumber
} from '@/utils/validate'

extend('required', {
  ...required,
  message: '必須項目です'
})

extend('email', {
  ...email,
  message: '正しいメールアドレスを入力してください'
})

extend('integer', {
  ...integer,
  message: '数字を入力してください'
})

extend('max', {
  ...max,
  message: '{length}文字以内で入力してください'
})

extend('url', {
  message: '正しいURLを入力してください',
  validate(value: string) {
    return isURL(value)
  }
})

extend('kana', {
  message: 'カタカナで入力してください',
  validate(value: string) {
    return isKana(value)
  }
})

extend('kana_alphabet', {
  message: 'カタカナまたはアルファベットで入力してください',
  validate(value: string) {
    return isKanaAlphabet(value)
  }
})

extend('postal_code', {
  message: '正しい郵便番号（-なし）を入力してください',
  validate(value: string) {
    return isPostalCode(value)
  }
})

extend('phone_number', {
  message: '正しい携帯番号（-なし）を入力してください',
  validate(value: string) {
    return isPhoneNumber(value)
  }
})

extend('cell_phone_number', {
  message: '正しい携帯番号（-なし）を入力してください',
  validate(value: string) {
    return isCellPhoneNumber(value)
  }
})

extend('international_phone_number', {
  message: '正しい電話番号を入力してください',
  validate(value: string) {
    return isInternationalPhoneNumber(value)
  }
})

/**
 * 国番号に応じた電話番号バリデーション
 * +81の場合: 日本の携帯番号フォーマット（070/080/090から始まる11桁）
 * その他の場合: 国際電話番号フォーマット（5〜15桁の数字）
 */
extend('phone_number_with_country', {
  params: ['countryCode'],
  message: (_fieldName: string, params: Record<string, any> | undefined) => {
    if (params?.countryCode === '+81') {
      return '正しい携帯番号（-なし、070/080/090から始まる11桁）を入力してください'
    }
    return '正しい電話番号を入力してください'
  },
  validate(value: string, params: Record<string, any> | undefined) {
    const countryCode = params?.countryCode
    if (countryCode === '+81') {
      // 日本の場合: 070/080/090で始まる11桁、または先頭0省略の10桁
      return isCellPhoneNumberWithOptionalLeadingZero(value)
    }
    // その他の国: 5〜15桁の数字
    return isInternationalPhoneNumber(value)
  }
})
